/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { Provider } from "mobx-react";
import React, { useState, useEffect } from "react";
import { Provider as ProviderV3 } from "@react-spectrum/provider";
import { theme as darkTheme } from "@react-spectrum/theme-dark";
import { theme as defaultTheme } from "@react-spectrum/theme-default";
import ProviderV2 from "@react/react-spectrum/Provider";
import { providers, locale2 } from "dc-core";

const injectStores = (Component, stores) => props => (
  <Provider {...stores}>
    <Component {...props} />
  </Provider>
);

export default injectStores;

const v3Theme = {
  ...defaultTheme,
  dark: darkTheme.light
};

export const withRSPv3Provider = Component => props => (
  <ProviderV3 theme={v3Theme} height="100%" scale="medium">
    <Component {...props} />
  </ProviderV3>
);

export const V2ProviderWrapper = WrappedComponent => props => {
  const [theme, setTheme] = useState(undefined);
  const appLocale = locale2.getLocale();

  useEffect(() => {
    providers.theme().then(themeProvider => {
      themeProvider.getTheme().then(setTheme);
    });
  }, []);

  return theme ? (
    <ProviderV2
      style={{ backgroundColor: "inherit" }}
      locale={appLocale}
      theme={theme}
    >
      <WrappedComponent {...props} />
    </ProviderV2>
  ) : null;
};
